import { fetchWithAuth } from "../../../utils/api";

// Get Items with server-side pagination and filters
export const getItems = async ({
    orgId,
    pageNumber = 1,
    pageSize = 10,
    partNo = "",
    itemName = "",
    itemCode = ""
}) => {
    const response = await fetchWithAuth("IIM/GetItems", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ServiceName: "GetItems",
            PageNumber: pageNumber,
            PageSize: pageSize,
            Params: {
                OrgId: orgId,
                PartNo: partNo,
                ItemName: itemName,
                ItemCode: itemCode
            }
        })
    });

    if (!response.ok) {
        throw new Error("Failed to fetch items");
    }

    return response.json();
};

export const getInwards = async ({
    orgId,
    pageNumber = 1,
    pageSize = 10,
    fromDate,
    toDate,
    vehicleNumber = "",
    status = "ALL"
}) => {
    const response = await fetchWithAuth("IIM/GetInwards", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ServiceName: "GetInwards",
            PageNumber: pageNumber,
            PageSize: pageSize,
            Params: {
                OrgId: orgId,
                FromDate: fromDate,
                ToDate: toDate,
                VehicleNumber: vehicleNumber,
                Status: status
            }
        })
    });

    if (!response.ok) {
        throw new Error("Failed to fetch inward records");
    }

    return response.json();
};


export const manageInwards = async (formData) => {

    const response = await fetchWithAuth(
        "file_upload/ManageInwards",
        {
            method: "POST",
            body: formData
        }
    );

    if (!response.ok) {
        throw new Error("Failed to register inward record");
    }

    return response.json();
};

export const getInwardRecordDetails = async (orgId, inwardRecordId) => {
    const params = new URLSearchParams({
        OrgId: orgId,
        InwardRecordId: inwardRecordId
    });

    const response = await fetchWithAuth(
        `IIM/GetInwardRecordDetails?${params.toString()}`,
        {
            method: "GET"
        }
    );

    if (!response.ok) {
        throw new Error("Failed to fetch inward record details");
    }

    return response.json();
};

export const reviewInward = async (payload) => {
    const response = await fetchWithAuth("IIM/ManageInwards", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    });

    if (!response.ok) {
        throw new Error("Failed to save inward review");
    }

    return response.json();
};

// Get inward records that contain a given item (for the barcode dropdown)
// GET IIM/GetInwardRecordsByItem?OrgId=8523&ItemId=10
export const getInwardRecordsByItem = async (orgId, itemId) => {
    const params = new URLSearchParams({
        OrgId: orgId,
        ItemId: itemId
    });

    const response = await fetchWithAuth(
        `IIM/GetInwardRecordsByItem?${params.toString()}`,
        {
            method: "GET"
        }
    );

    if (!response.ok) {
        throw new Error("Failed to fetch inward records for item");
    }

    return response.json();
};

// Get barcode units (inventory units) for an inward record + item
// GET IIM/GetInventoryUnits?UnitStatus=ALL&InwardRecordId=1&GenerationFilter=ALL&ItemId=11
// generationFilter: "ALL" | "GENERATED" | "NOT_GENERATED"
export const getInventoryUnits = async ({
    unitStatus = "ALL",
    inwardRecordId = 0,
    generationFilter = "ALL",
    itemId = ""
} = {}) => {
    const params = new URLSearchParams({
        UnitStatus: unitStatus || "ALL",
        InwardRecordId: inwardRecordId ?? 0,
        GenerationFilter: generationFilter || "ALL"
    });

    // Send ItemId only when we have one (inward view loads all items)
    if (itemId !== undefined && itemId !== null && itemId !== "") {
        params.append("ItemId", itemId);
    }

    const response = await fetchWithAuth(
        `IIM/GetInventoryUnits?${params.toString()}`,
        {
            method: "GET"
        }
    );

    if (!response.ok) {
        throw new Error("Failed to fetch inventory units");
    }

    return response.json();
};

// Approve inward into inventory + save generated barcodes
// POST IIM/ApproveToInventory
// { OrgId, InwardRecordId, Action: "UPDATE_INVENTORY", UserId, UnitsJson: [{ RecordItemId, Barcode }] }
export const approveInward = async (payload) => {
    const response = await fetchWithAuth("IIM/ApproveToInventory", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    });

    if (!response.ok) {
        throw new Error("Failed to approve inward");
    }

    return response.json();
};


// Inwards of an item with barcode generation status
// GET IIM/GetInwardsbyItem?OrgId=8523&ItemId=11
// -> [{ InwardRecordId, InwardRecordNo, ArrivalDate, VerifiedQuantity, AlreadyGenerated, ToGenerate }]
export const getInwardsByItem = async (orgId, itemId) => {
    const params = new URLSearchParams({ OrgId: orgId, ItemId: itemId });

    const response = await fetchWithAuth(`IIM/GetInwardsbyItem?${params.toString()}`, {
        method: "GET"
    });

    if (!response.ok) {
        throw new Error("Failed to fetch inwards for item");
    }

    return response.json();
};

// Rework tab: units of all items (ItemId = 0) or one item
// GET IIM/GetInventoryUnits?OrgId=8523&ItemId=0
export const getReworkUnits = async ({ orgId, itemId = 0 }) => {
    const params = new URLSearchParams({
        OrgId: orgId,
        ItemId: itemId || 0
    });

    const response = await fetchWithAuth(`IIM/GetItemsDDL?${params.toString()}`, {
        method: "GET"
    });

    if (!response.ok) {
        throw new Error("Failed to fetch rework units");
    }

    return response.json();
};